import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { getMyPlaylists, addPlaylistItem } from "../../functions/playlist";
import useClickOutside from "../../helpers/clickOutside";
import "./style.css";

export default function AddToPlaylistMenu({
  visible,
  onClose,
  itemType, // "video", "live", "story"
  itemId,
  onCreateNew,
}) {
  const { user } = useSelector((state) => ({ ...state }));
  const [playlists, setPlaylists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addedTo, setAddedTo] = useState([]);
  const menuRef = useRef(null);

  useClickOutside(menuRef, () => {
    if (visible) onClose();
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (visible) {
      loadPlaylists();
    }
  }, [visible]);

  const loadPlaylists = async () => {
    setLoading(true);
    const res = await getMyPlaylists(user.token);
    if (res.status === "ok") {
      setPlaylists(res.data);
      // Verificar em quais playlists o item já está
      const alreadyIn = res.data
        .filter((p) =>
          p.items?.some((item) => {
            if (itemType === "video") return item.postRef === itemId;
            if (itemType === "live") return item.liveRef === itemId;
            if (itemType === "story") return item.storyRef === itemId;
            return false;
          })
        )
        .map((p) => p._id);
      setAddedTo(alreadyIn);
    }
    setLoading(false);
  };

  const handleAddToPlaylist = async (playlistId) => {
    if (addedTo.includes(playlistId)) return;

    const res = await addPlaylistItem(
      playlistId,
      { itemType, itemId },
      user.token
    );

    if (res.status === "ok") {
      setAddedTo([...addedTo, playlistId]);
    }
  };

  if (!visible) return null;

  return (
    <div className="add_to_playlist_menu" ref={menuRef}>
      <div className="add_to_playlist_header">Adicionar à Playlist</div>

      <div className="add_to_playlist_list">
        {loading ? (
          <div style={{ padding: "20px", textAlign: "center" }}>
            Carregando...
          </div>
        ) : playlists.length === 0 ? (
          <div
            style={{
              padding: "20px",
              textAlign: "center",
              color: "var(--color-secondary)",
            }}
          >
            Nenhuma playlist encontrada
          </div>
        ) : (
          playlists.map((playlist) => (
            <div
              key={playlist._id}
              className="add_to_playlist_item"
              onClick={() => handleAddToPlaylist(playlist._id)}
            >
              {playlist.thumbnail ? (
                <img src={playlist.thumbnail} alt="" />
              ) : (
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 4,
                    background: "var(--blue-color)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="white"
                  >
                    <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z" />
                  </svg>
                </div>
              )}
              <span>{playlist.title}</span>
              {addedTo.includes(playlist._id) && (
                <svg className="check_icon" viewBox="0 0 24 24">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
              )}
            </div>
          ))
        )}
      </div>

      <div className="add_to_playlist_new" onClick={onCreateNew}>
        <svg viewBox="0 0 24 24">
          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
        </svg>
        <span>Criar nova playlist</span>
      </div>
    </div>
  );
}
